import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'formik';

import Grid from '@material-ui/core/Grid';
import { LabelTooltip } from 'core/components/label-tooltip';
import { FormField } from 'core/components/form';
import { tooltipHoverTexts } from 'core/helpers/constants';

const ColoradoAutoLimits = ({ id, disabled, UMBIOptions }) => {
  return (
    <Grid item xs={6}>
      <LabelTooltip
        label="Un/Underinsured Motorist BI"
        tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.umUimBodilyInjury }}
      >
        <FormField
          mode="dark"
          name={`${id}.policyLimitUMBI`}
          id={`${id}.policyLimitUMBI`}
          type="select"
          options={UMBIOptions}
          optional
          disabled={disabled}
          fast={false}
        />
      </LabelTooltip>
    </Grid>
  );
};

ColoradoAutoLimits.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  UMBIOptions: PropTypes.array.isRequired
};

ColoradoAutoLimits.defaultProps = {
  disabled: false
};

export default connect(ColoradoAutoLimits);
